<template>
    <v-flex xs2>
        
        <v-select 
        :items="items"
        v-model="selectedPeriod"
        label="Period"
        dark
        solo-inverted
        flat
        prepend-icon="date_range"
        
        ></v-select>
    </v-flex>
   
</template>
<script>
    import { getPeriods, initialize } from '../utils/effort-tracking-api'
    import { EventBus } from '../utils/event-bus.js'
    import { globalStore } from '../main.js'
    import { store } from '../store.js'

    export default {
        name: "period-selector",
        props: ['periods'],
        data () {
            return {
                selectedPeriod: 0,
                items: [],
                isTeacher: false,
                isStudent: false,
                defaultPeriod: 0
            }
        },
        watch: {
            selectedPeriod: function(val) {
                if (val != null)
                {
                    globalStore.selectedPeriod = val;
                    localStorage.setItem('period-selected', val);
                    this.$emit('period-selected', val);
                }
            }
        },
        methods: {
            selectDefaultPeriod(periodId)
            {
                this.selectedPeriod = periodId;
            },
            update() {
                initialize().then(x => {
                    getPeriods().then( reportingPeriods => {
                        store.state.periods = [];
                        reportingPeriods.forEach(period => {
                            var date = new Date();
                            var sdate = new Date(period.startDate);
                            var edate = new Date(period.endDate);
                            edate.setDate(edate.getDate() + 1);

                            var p = {
                                text: period.text,
                                id: period.value,
                                startDate: sdate,
                                endDate: edate,
                                active: period.active,
                                visible: period.visible,
                                complete: period.complete
                            };

                            if(store.state.usertype != 'admin')
                            {
                                if(p.visible)
                                    store.state.periods.push(p);

                                this.items = reportingPeriods.filter(rpp => rpp.visible);

                            } else {
                                store.state.periods.push(p);
                                this.items = reportingPeriods;
                            }

                            // console.log('Periods: ');
                            // console.log(this.items);
                        });
                        }).catch(ex => console.log(ex));
                }).catch(ex => console.log(ex));
            },
            selectSelectedPeriod() {
                var lsPeriod = localStorage.getItem('period-selected');
                console.log('Selected reporting period:');
                console.log(lsPeriod);
                
                if(globalStore.selectedPeriod == 0)
                {
                    globalStore.selectedPeriod = lsPeriod;
                }
                return lsPeriod;
            }
        },
        mounted() {
            this.isStudent = (this.$store.state.usertype == 'student' ? true : false);
            this.isTeacher = (this.$store.state.usertype == 'teacher' || this.$store.state.usertype == 'middlemanager' ? true : false);
            this.update();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PeriodSelector.vue